import {Component, EventEmitter, Input, OnInit, Output, SimpleChanges} from '@angular/core';
import {QuestionFlowSessionQuery} from '../../questions/state/question-flow-session.query';
import {Question} from '../../models/underwriter.model';
import {AuthenticationService} from '../../../authentication/service/authentication.service';
import {UserStore} from '../../../authentication/state/user.store';
import {newGuid} from '../../questions/question-helper';
import {API_PATH, RouterLinks} from '../../constants';
import {GlobalQuestionService} from '../../services/global-question.service';
import {Router} from '@angular/router';
import { ComponentsService } from '../../services/components-service';

declare const $: any;
declare const Dropzone: any;
declare const dropzonePreviewTemplate: any;

@Component({
    selector: 'app-question-mini-form-modal',
    templateUrl: './question-mini-form-modal.component.html',
    styleUrls: ['./question-mini-form-modal.component.scss'],
    standalone: false
})
export class QuestionMiniFormModalComponent implements OnInit {

  session_details: any;
  note = '';
  dropZone: any;
  acceptedFileTypes = 'image/*';
  fileSelectorEl = `question-note-uploader-${newGuid()}`;
  savedResources: any[] = [];
  buttonDisabled = true;
  @Input() question: any;
  @Output() noteChanged = new EventEmitter<Question>();
  questions: any;
  edit = false;
  constructor(
    private questionSession: QuestionFlowSessionQuery,
    private authService: AuthenticationService,
    private userStore: UserStore,
    private componentsService: ComponentsService,
    private questionService: GlobalQuestionService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.session_details = this.questionSession.getValue();
    //this.questions = JSON.parse('miniFormQuestions');
    this.componentsService.getMiniFormQuestion().subscribe( questions => {
       this.questions = questions;
       console.log(this.questions)
       this.edit = false;
       if (this.questions.every(q => q.answer) ) {
        this.edit = true;
      }
     });
    
  }
  ngAfterViewInit(): void{
    // demo new dialog functionality
    const addFamilyMemberModal = document.getElementById('mini-form-modal');

    // modal can be triggered by attaching data-toggle="dialog" to a clickable element, or by calling showModal() on the modal element
    
    // open modal
    // addFamilyMemberModal.showModal();

    // close modal
    // addFamilyMemberModal.close();

   
    // open callback
    addFamilyMemberModal.addEventListener('dialog-open', function(){
        console.log('dialog opened');     
    });
    
    // close callback
    addFamilyMemberModal.addEventListener('close', function () {
        console.log('dialog closed');
    });

  }

  showModal(question: Question): void {
    this.note = '';
    this.savedResources = [];
    this.buttonDisabled = true;
    this.question = question;
    if (this.question?.comment) {
      this.note = this.question?.comment;
      this.buttonDisabled = false;
    }
    /*if (this.dropZone) {
      this.dropZone?.destroy();
    }
    this.refreshToken();*/
    $('#question-add-note__modal').modal('show');
  }

  refreshToken(): void {
    this.authService.refreshToken()
      .subscribe(x => {
        this.userStore.update({
          access_token: x?.access_token,
          refresh_token: x?.refresh_token
        });
        this.initDropzone(x?.access_token);
      });
  }
  ngOnChanges(changes: SimpleChanges): void {
    
  }
  onChange(event:any,index: any): void {
    console.log(this.questions)
    if (this.questions.every(q => q.answer) ) {
      this.buttonDisabled = null;
    }
    else{
      this.buttonDisabled = true;
    }
    
  }

  initDropzone(token: string): void {
    this.dropZone = new Dropzone(`#${this.fileSelectorEl}`, {
      autoProcessQueue: true, // if false, call this.dropZone.processQueue()
      autoDiscover: false,
      acceptedFiles: this.acceptedFileTypes,
      previewTemplate: dropzonePreviewTemplate,
      thumbnailWidth: 204,
      thumbnailHeight: 204,
      maxFilesize: 200,
      url: API_PATH.UPLOAD_RESOURCE,
      headers: {
        Authorization: `Bearer ${token}`
      },
    }).on('thumbnail', (file: any) => {
      $(file.previewElement).addClass('has-thumbnail');
    }).on('success', (file: any, response: any) => {
      if (!this.savedResources || this.savedResources?.length) {
        this.savedResources = [];
      }
      this.savedResources.push({resource_id: response, file: file?.upload?.uuid});
    }).on('removedfile', (file: any) => {
      const deletedFile = this.savedResources.find((item: any) => item.file === file?.upload?.uuid);
      if (deletedFile) {
        this.savedResources = this.savedResources.filter(item => item.file !== file?.upload?.uuid);
        this.removeFile(deletedFile.resource_id);
      }
    }).on('error', (file: any, response: any) => {
      if (response?.indexOf('401') !== -1) {
        this.router.navigate([RouterLinks.Login], {queryParams: {returnUrl: this.router.routerState.snapshot.url}});
      }
    });

    if (this.question?.comment_files) {
      const response = JSON.parse(this.question?.comment_files);

      response.forEach((res: any) => {
        const resource_id = res.resource_id;
        const mockFile = {
          name: resource_id,
          size: 12345
        };
        this.dropZone.emit('addedfile', mockFile);
        this.dropZone.emit('thumbnail', mockFile, `${API_PATH.UPLOAD_RESOURCE}/${resource_id}`);
        this.dropZone.emit('success', mockFile, resource_id);
      });

    }
  }

  removeFile(resource_id: string): void {
    this.questionService.removeFile(resource_id);
  }

  deleteNote(): void {
    this.question.comment = '';
    /*this.question.note_files = '';*/
    this.noteChanged.emit(this.question);
    $('#question-add-note__modal').modal('hide');
  }

  addItem(): void {
    this.componentsService.setMiniFormQuestion(this.questions);
  }

}
